import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './_share/components/forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './_share/components/forgot-username/forgot-username.component';
import { LoginComponent } from './_share/pages/login/login.component';

const routes: Routes = [
  // Auth routes (rendered without sidebar)
  {
    path: 'login',
    component: LoginComponent,
    title: 'STEM OM | Login'
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    title: 'STEM OM | Forgot Password'
  },
  {
    path: 'forgot-username',
    component: ForgotUsernameComponent,
    title: 'STEM OM | Forgot Username'
  },

  {
    path: 'portal',
    children: [
      {
        path: '',
        loadChildren: () => import('./features/portal/portal.module').then((m) => m.PortalModule)
      },
      { path: '**', redirectTo: '' }
    ],
    title: 'Portal'
  },
  {
    path: '',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/main-application/main.module').then((m) => m.MainModule)
      }
    ],
    title: 'STEM | OM'
  },
  // {
  //   path: 'crm',
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('./features/crm/crm.module').then((m) => m.CrmModule)
  //     }
  //   ],
  //   title: 'STEM | CRM'
  // },

  // {
  //   path: 'business',
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () =>
  //         import('./features/business-sales/business-sales.module').then(
  //           (m) => m.BusinessSalesModule
  //         )
  //     }
  //     // { path: '**', redirectTo: '' },
  //   ],
  //   title: 'STEM | Business Sales'
  // },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
